import { IYearMonth } from '@/coreDomainsModule/date';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { LoadingState } from '@/coreDomainsModule/uiLoadingState';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { DashboardInformation } from '@/inventoryDashboardModule/domains/entities/Dashboard';

/**
 * InventoryDashboardの状態を表すinterface
 */
export interface IInventoryDashboardState {
  nowViewType: ViewType;
  displayYearMonth: IYearMonth;
  displayYearMonthPeriod: [IYearMonth, IYearMonth];
  forecastAccuracyPeriod: number | undefined;
  filterItems: FilterContentItem[];
  checkedBusinessId: string[];
  overviewData: OverviewData;
  information: DashboardInformation;
  informationLoadingState: LoadingState;
}

export const ViewType = { Graph: 'graph', List: 'list' } as const;
/**
 * 表示する画面のタイプ
 */
export type ViewType = (typeof ViewType)[keyof typeof ViewType];

export const OverviewData = [
  'totalCurrentInventoryAmount',
  'averageTurnover',
  'averageForecastAccuracy',
  'averageKpiArchievementRate',
  'warningItemsCount',
  'criticalItemsCount',
] as const;
/**
 * 概要カードで表示するデータキー
 */
export type OverviewDataType = (typeof OverviewData)[number];

/**
 * 在庫管理ダッシュボードの概要データ(集計)タイプ
 */
export type OverviewData = Record<OverviewDataType, number | undefined>;

/**
 * 在庫管理ダッシュボード詳細データ(集計)タイプ
 */
export type DetailAggregateBusinessData = IBusiness & {
  latestInventoryAmount: number | undefined;
  lastMonthEndInventoryAmount: number | undefined;
  lastMonthSalesResultAmount: number | undefined;
  turnover: number | undefined;
};

/**
 * 在庫管理ダッシュボード詳細データ(関連取引)タイプ
 */
export type DetailBaseBusinessData = IBusiness & {
  aggregateBusinessId: string | undefined;
  lastMonthSalesResultAmount: number | undefined;
  lastMonthCustomerForecastAmount: number | undefined;
  forecastAccuracy: number | undefined;
};

/**
 * 在庫管理ダッシュボード詳細データ(集計)タイプ
 */
export type DetailAlertBusinessData = IBusiness & {
  alertType: string[];
};

/**
 * 在庫管理ダッシュボード詳細データ(集計)タイプ
 */
export type DetailAlertData = {
  overview: {
    excess: number;
    shortage: number;
    unresolved: {
      unmatched: number;
      noOrderNumber: number;
      deadline: number;
    };
  };
  businesses: DetailAlertBusinessData[];
};
